(function () {
  var mobileQuery = window.matchMedia('(max-width: 760px)');
  var path = window.location.pathname.replace(/\/$/, '');
  var html = document.documentElement;
  var isCataloguePath = /\/pages\/catalogue$/.test(path);
  var isFinancePath = /\/pages\/financing$/.test(path);
  var catalogueObserver = null;
  var catalogueObservedGrid = null;
  var drawerSortBinding = null;
  var catalogueImageStyles = new WeakMap();
  var catalogueToggleLabels = new WeakMap();
  var catalogueViewClassAdditions = new WeakSet();

  if (isFinancePath) {
    html.classList.add('rl-mobile-repair-finance');
  }

  if (isCataloguePath) {
    html.classList.add('rl-mobile-repair-catalogue');
  }

  function text(el) {
    return (el && el.textContent || '').replace(/\s+/g, ' ').trim();
  }

  function updateFinanceHeading() {
    if (!isFinancePath) return;
    var headings = document.querySelectorAll('h1, h2, h3, strong');
    headings.forEach(function (heading) {
      var current = text(heading).toUpperCase();
      if (current === 'BUILD THE EQUIPMENT QUOTE FIRST, THEN EXPLORE FINANCE.') {
        if (!heading.dataset.rlOriginalText) heading.dataset.rlOriginalText = heading.textContent;
        heading.textContent = mobileQuery.matches
          ? 'BUILD YOUR QUOTE, THEN EXPLORE FINANCE'
          : heading.dataset.rlOriginalText;
      }
    });
  }

  function repairQuoteHelpCards() {
    if (!mobileQuery.matches) return;
    var cartPage = document.querySelector('.rlm-cart-page');
    if (!cartPage) return;
    cartPage.querySelectorAll('.rlm-wide-callout, .rlm-quote-support').forEach(function (card) {
      if (!/(Need help choosing\?|Need help finalising your quote\?)/i.test(text(card))) return;
      var strong = card.querySelector('strong');
      if (strong) {
        strong.textContent = 'Need help choosing?';
      }
      var small = card.querySelector('small');
      if (small) {
        small.textContent = 'Our team can help with equipment advice, space planning and setup.';
      }
    });
  }

  function ensureDrawerSort(root) {
    var panel = root.querySelector('.rl-filter-panel');
    var toolbarSort = root.querySelector('.rl-toolbar__actions [data-rl-catalogue-sort], .rl-toolbar__actions select');
    if (drawerSortBinding && drawerSortBinding.toolbarSort !== toolbarSort) cleanupDrawerSort();
    if (!panel || !toolbarSort || panel.querySelector('.rl-filter-group--mobile-sort')) return;

    var group = document.createElement('div');
    group.className = 'rl-filter-group rl-filter-group--sort rl-filter-group--mobile-sort';
    group.dataset.rlMobileRepairAdded = 'true';
    group.innerHTML = '<h4 class="rl-filter-group__title">Sort equipment</h4>';

    var label = document.createElement('label');
    label.className = 'rl-catalogue-sort rl-catalogue-sort--drawer';
    var hidden = document.createElement('span');
    hidden.className = 'visually-hidden';
    hidden.textContent = 'Sort equipment';

    var clone = toolbarSort.cloneNode(true);
    clone.removeAttribute('id');
    clone.setAttribute('aria-label', 'Sort equipment');
    clone.value = toolbarSort.value;
    var onCloneChange = function () {
      toolbarSort.value = clone.value;
      toolbarSort.dispatchEvent(new Event('change', { bubbles: true }));
    };
    var onToolbarChange = function () {
      clone.value = toolbarSort.value;
    };
    clone.addEventListener('change', onCloneChange);
    toolbarSort.addEventListener('change', onToolbarChange);

    label.appendChild(hidden);
    label.appendChild(clone);
    group.appendChild(label);
    panel.insertBefore(group, panel.firstChild);
    drawerSortBinding = {
      group: group,
      toolbarSort: toolbarSort,
      clone: clone,
      onCloneChange: onCloneChange,
      onToolbarChange: onToolbarChange
    };
  }

  function cleanupDrawerSort() {
    if (!drawerSortBinding) return;
    drawerSortBinding.clone.removeEventListener('change', drawerSortBinding.onCloneChange);
    drawerSortBinding.toolbarSort.removeEventListener('change', drawerSortBinding.onToolbarChange);
    drawerSortBinding.group.remove();
    drawerSortBinding = null;
  }

  function stopCatalogueObserver() {
    if (catalogueObserver) catalogueObserver.disconnect();
    catalogueObserver = null;
    catalogueObservedGrid = null;
  }

  function startCatalogueObserver(root) {
    var grid = root.querySelector('[data-rl-catalogue-grid]') || root;
    if (catalogueObserver && catalogueObservedGrid === grid) return;
    stopCatalogueObserver();
    catalogueObservedGrid = grid;
    catalogueObserver = new MutationObserver(function () {
      if (!mobileQuery.matches || !root.isConnected) return;
      repairCatalogueCards(root);
    });
    catalogueObserver.observe(grid, { childList: true, subtree: true });
  }

  function cleanupCatalogueRepairs(root) {
    stopCatalogueObserver();
    cleanupDrawerSort();
    root.querySelectorAll('[data-rl-mobile-repair-added]').forEach(function (node) {
      node.remove();
    });
    root.querySelectorAll('[data-rl-catalogue-filter-toggle]').forEach(function (toggle) {
      var label = toggle.querySelector('span');
      if (!label || !catalogueToggleLabels.has(label)) return;
      label.textContent = catalogueToggleLabels.get(label);
      catalogueToggleLabels.delete(label);
    });
    root.querySelectorAll('.rl-link-button--view').forEach(function (view) {
      if (!catalogueViewClassAdditions.has(view)) return;
      view.classList.remove('rl-link-button--view');
      catalogueViewClassAdditions.delete(view);
    });
    root.querySelectorAll('.rl-product-card__media img, .rl-product-card__media svg').forEach(function (image) {
      var previous = catalogueImageStyles.get(image);
      if (!previous) return;
      Object.keys(previous).forEach(function (property) {
        var value = previous[property].value;
        var priority = previous[property].priority;
        if (value) image.style.setProperty(property, value, priority);
        else image.style.removeProperty(property);
      });
      catalogueImageStyles.delete(image);
    });
  }

  function repairCatalogueImage(image) {
    var repairs = {
      filter: 'none',
      'mix-blend-mode': 'normal',
      'object-fit': 'contain',
      'object-position': 'center bottom',
      transform: 'none'
    };
    if (!catalogueImageStyles.has(image)) {
      var previous = {};
      Object.keys(repairs).forEach(function (property) {
        previous[property] = {
          value: image.style.getPropertyValue(property),
          priority: image.style.getPropertyPriority(property)
        };
      });
      catalogueImageStyles.set(image, previous);
    }
    Object.keys(repairs).forEach(function (property) {
      image.style.setProperty(property, repairs[property], 'important');
    });
  }

  function repairCatalogueCards(root) {
    var quoteUrl = root.dataset.quoteUrl || '/pages/contact';
    root.querySelectorAll('[data-rl-catalogue-filter-toggle]').forEach(function (toggle) {
      if (!/filters/i.test(text(toggle))) {
        var label = toggle.querySelector('span');
        if (label) {
          if (!catalogueToggleLabels.has(label)) catalogueToggleLabels.set(label, label.textContent);
          label.textContent = 'Filters';
        }
      }
    });
    root.querySelectorAll('.rl-product-card').forEach(function (card) {
      card.querySelectorAll('.rl-product-card__media img, .rl-product-card__media svg').forEach(repairCatalogueImage);
      var actions = card.querySelector('.rl-product-card__actions');
      if (!actions) return;

      var view = Array.prototype.find.call(actions.querySelectorAll('a'), function (link) {
        return /view product/i.test(text(link));
      });
      if (view && !view.classList.contains('rl-link-button--view')) {
        view.classList.add('rl-link-button--view');
        catalogueViewClassAdditions.add(view);
      }

      if (!actions.querySelector('.rl-link-button--guidance')) {
        var guidance = document.createElement('a');
        guidance.className = 'rl-link-button rl-link-button--guidance';
        guidance.dataset.rlMobileRepairAdded = 'true';
        guidance.href = quoteUrl;
        guidance.textContent = 'Request guidance';
        actions.appendChild(guidance);
      }
    });
  }

  function repairCatalogue() {
    if (!isCataloguePath) return;
    var root = document.querySelector('[data-rl-catalogue-root]');
    if (!root) {
      stopCatalogueObserver();
      cleanupDrawerSort();
      return;
    }
    if (!mobileQuery.matches) {
      cleanupCatalogueRepairs(root);
      return;
    }
    ensureDrawerSort(root);
    repairCatalogueCards(root);
    startCatalogueObserver(root);
  }

  function escapeHtml(value) {
    var span = document.createElement('span');
    span.textContent = value || '';
    return span.innerHTML;
  }

  function repairMobileSearchPredictive() {
    var root = document.querySelector('[data-rlm-predictive-search]');
    if (!root) return;

    var input = root.querySelector('[data-rlm-predictive-input]');
    var results = root.querySelector('[data-rlm-predictive-results]');
    if (!input || !results) return;

    if (!mobileQuery.matches) {
      if (typeof root.rlmPredictiveCancel === 'function') {
        root.rlmPredictiveCancel();
      } else {
        results.hidden = true;
        input.setAttribute('aria-expanded', 'false');
        input.setAttribute('aria-activedescendant', '');
        root.setAttribute('aria-busy', 'false');
        results.setAttribute('aria-busy', 'false');
      }
      return;
    }

    if (root.dataset.rlmPredictiveBound) return;
    root.dataset.rlmPredictiveBound = 'true';

    var endpoint = root.getAttribute('data-rlm-predictive-endpoint') || (window.Theme && window.Theme.routes && window.Theme.routes.predictive_search_url) || '/search/suggest';
    var timer = null;
    var controller = null;
    var requestToken = 0;
    var activeIndex = -1;
    var listboxId = results.id + '-listbox';
    var status = root.querySelector('[data-rlm-predictive-status]');
    var predictiveSearchTimeoutMs = 8000;

    input.setAttribute('role', 'combobox');
    input.setAttribute('aria-autocomplete', 'list');
    input.setAttribute('aria-haspopup', 'listbox');
    input.removeAttribute('aria-controls');
    input.setAttribute('aria-activedescendant', '');

    function currentTerm() {
      return input.value.replace(/\s+/g, ' ').trim();
    }

    function options() {
      return Array.prototype.slice.call(results.querySelectorAll('[role="option"]'));
    }

    function announce(message) {
      if (status) status.textContent = message || '';
    }

    function setBusy(isBusy) {
      root.setAttribute('aria-busy', isBusy ? 'true' : 'false');
      results.setAttribute('aria-busy', isBusy ? 'true' : 'false');
    }

    function cancelRequest() {
      requestToken += 1;
      if (controller) controller.abort();
      controller = null;
      setBusy(false);
    }

    function setActive(index) {
      var available = options();
      if (!available.length) {
        activeIndex = -1;
        input.setAttribute('aria-activedescendant', '');
        return;
      }
      activeIndex = Math.max(0, Math.min(index, available.length - 1));
      available.forEach(function (option, optionIndex) {
        var selected = optionIndex === activeIndex;
        option.setAttribute('aria-selected', selected ? 'true' : 'false');
        option.classList.toggle('is-active', selected);
      });
      input.setAttribute('aria-activedescendant', available[activeIndex].id);
      available[activeIndex].scrollIntoView({ block: 'nearest' });
    }

    function setOpen(isOpen) {
      results.hidden = !isOpen;
      input.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      if (!isOpen) input.removeAttribute('aria-controls');
    }

    function closeResults() {
      window.clearTimeout(timer);
      cancelRequest();
      activeIndex = -1;
      results.innerHTML = '';
      input.setAttribute('aria-activedescendant', '');
      announce('');
      setOpen(false);
    }

    root.rlmPredictiveCancel = closeResults;

    function renderStatus(message, retryable) {
      results.innerHTML = '<p class="rlm-search-suggestions__status">' + escapeHtml(message) + '</p>' + (retryable ? '<button class="rlm-search-suggestions__all" type="button" data-rlm-predictive-retry>Try preview again</button>' : '');
      activeIndex = -1;
      input.removeAttribute('aria-controls');
      input.setAttribute('aria-activedescendant', '');
      announce(message);
      setOpen(true);
    }

    function productImage(anchor) {
      var media = anchor.querySelector('.search-flydown--product-image img, .search-flydown--product-image svg');
      if (media) {
        var clone = media.cloneNode(true);
        var image = clone.matches('img') ? clone : clone.querySelector && clone.querySelector('img');
        if (image) {
          image.removeAttribute('srcset');
          image.removeAttribute('sizes');
          Array.prototype.slice.call(image.attributes).forEach(function (attribute) {
            if (/^data-rimg/i.test(attribute.name)) image.removeAttribute(attribute.name);
          });
          image.setAttribute('loading', 'lazy');
          image.setAttribute('decoding', 'async');
        }
        return clone.outerHTML;
      }
      return '<span aria-hidden="true"></span>';
    }

  function productMeta(anchor, title) {
    var text = anchor.querySelector('.search-flydown--product-text');
    if (!text) return '';
    var meta = text.textContent.replace(/\s+/g, ' ').trim();
    if (title) meta = meta.replace(title, '').trim();
    var prices = meta.match(/£\d[\d,]*(?:\.\d{2})?/g) || [];
    var uniquePrices = [];
    prices.forEach(function (price) {
      if (uniquePrices.indexOf(price) === -1) uniquePrices.push(price);
    });
    if (uniquePrices.length > 1) return uniquePrices[0] + ' - ' + uniquePrices[1];
    if (uniquePrices.length === 1) return uniquePrices[0];
    return meta;
  }

    function renderProducts(html, term) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var anchors = Array.prototype.slice.call(doc.querySelectorAll('.search-flydown--product')).slice(0, 5);
      if (!anchors.length) {
        renderStatus('No quick matches yet. Try a product name, range or model number.');
        return;
      }

      var items = anchors.map(function (anchor, index) {
        var titleNode = anchor.querySelector('.search-flydown--product-title');
        var title = (titleNode ? titleNode.textContent : anchor.getAttribute('aria-label') || '').replace(/\s+/g, ' ').trim();
        var searchForm = input.form || (root.matches('form') ? root : root.querySelector('form'));
        var searchUrl = searchForm && searchForm.action || (window.Theme && window.Theme.routes && window.Theme.routes.search_url) || '/search';
        var href = anchor.getAttribute('href') || searchUrl + '?q=' + encodeURIComponent(term);
        var meta = productMeta(anchor, title);
        return '<li class="rlm-search-suggestions__item" role="presentation"><a id="' + listboxId + '-option-' + index + '" class="rlm-search-suggestions__link" href="' + escapeHtml(href) + '" role="option" aria-selected="false" tabindex="-1"><span class="rlm-search-suggestions__media">' + productImage(anchor) + '</span><span><strong class="rlm-search-suggestions__title">' + escapeHtml(title) + '</strong>' + (meta ? '<small class="rlm-search-suggestions__meta">' + escapeHtml(meta) + '</small>' : '') + '</span></a></li>';
      }).join('');

      var searchForm = input.form || (root.matches('form') ? root : root.querySelector('form'));
      var searchUrl = searchForm && searchForm.action || (window.Theme && window.Theme.routes && window.Theme.routes.search_url) || '/search';
      results.innerHTML = '<p class="rlm-search-suggestions__label" aria-hidden="true">Top matches</p><ul class="rlm-search-suggestions__list" id="' + listboxId + '" role="listbox" aria-label="Product search suggestions">' + items + '</ul><a class="rlm-search-suggestions__all" href="' + escapeHtml(searchUrl) + '?type=product&q=' + encodeURIComponent(term) + '">View all results for "' + escapeHtml(term) + '"</a>';
      input.setAttribute('aria-controls', listboxId);
      activeIndex = -1;
      input.setAttribute('aria-activedescendant', '');
      announce(anchors.length + (anchors.length === 1 ? ' product suggestion available.' : ' product suggestions available.'));
      setOpen(true);
    }

    function search(term) {
      if (term.length < 2) {
        closeResults();
        return;
      }

      cancelRequest();
      controller = new AbortController();
      var requestController = controller;
      var token = requestToken;
      var timedOut = false;
      var timeoutId = 0;
      setBusy(true);
      renderStatus('Searching equipment...');

      var url = endpoint + '?q=' + encodeURIComponent(term) + '&resources[type]=product&resources[limit]=6&section_id=predictive-search';
      var request = fetch(url, { signal: requestController.signal })
        .then(function (response) {
          if (!response.ok) throw new Error(response.status);
          return response.text();
        });
      var timeout = new Promise(function (resolve, reject) {
        timeoutId = window.setTimeout(function () {
          timedOut = true;
          var error = new Error('Predictive search timed out');
          error.name = 'TimeoutError';
          reject(error);
          requestController.abort();
        }, predictiveSearchTimeoutMs);
      });

      Promise.race([request, timeout])
        .then(function (html) {
          if (token !== requestToken || currentTerm() !== term) return;
          renderProducts(html, term);
        })
        .catch(function (error) {
          if (token !== requestToken || currentTerm() !== term) return;
          if (error.name === 'AbortError' && !timedOut) return;
          renderStatus(
            timedOut
              ? 'Search preview took too long. Try again or submit the search to see all results.'
              : 'Search preview is unavailable. Try again or submit the search to see all results.',
            true
          );
        })
        .finally(function () {
          window.clearTimeout(timeoutId);
          if (token !== requestToken) return;
          if (controller === requestController) controller = null;
          setBusy(false);
        });
    }

    input.addEventListener('input', function () {
      var term = currentTerm();
      window.clearTimeout(timer);
      cancelRequest();
      results.innerHTML = '';
      input.setAttribute('aria-activedescendant', '');
      announce('');
      setOpen(false);
      if (term.length < 2) return;
      timer = window.setTimeout(function () {
        search(term);
      }, 180);
    });

    input.addEventListener('focus', function () {
      var term = currentTerm();
      if (term.length > 1 && results.hidden) search(term);
    });

    input.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        event.preventDefault();
        closeResults();
        return;
      }

      var available = options();
      if ((event.key === 'ArrowDown' || event.key === 'ArrowUp' || event.key === 'Home' || event.key === 'End') && available.length) {
        event.preventDefault();
        if (event.key === 'Home') setActive(0);
        else if (event.key === 'End') setActive(available.length - 1);
        else if (event.key === 'ArrowDown') setActive(activeIndex < available.length - 1 ? activeIndex + 1 : 0);
        else setActive(activeIndex > 0 ? activeIndex - 1 : available.length - 1);
        return;
      }

      if (event.key === 'Enter' && !event.isComposing && input.form) {
        event.preventDefault();
        if (activeIndex > -1 && available[activeIndex]) {
          window.location.assign(available[activeIndex].href);
          return;
        }
        closeResults();
        if (typeof input.form.requestSubmit === 'function') input.form.requestSubmit();
        else input.form.submit();
      }
    });

    results.addEventListener('click', function (event) {
      var retry = event.target.closest('[data-rlm-predictive-retry]');
      if (!retry) return;
      event.preventDefault();
      input.focus({ preventScroll: true });
      search(currentTerm());
    });

    root.addEventListener('focusout', function () {
      window.setTimeout(function () {
        if (!root.contains(document.activeElement)) closeResults();
      }, 0);
    });

    document.addEventListener('click', function (event) {
      if (!root.contains(event.target)) closeResults();
    });
  }

  function repairMobileProductVariants() {
    var alreadyBound = html.dataset.rlmVariantSyncBound === 'true';
    var activeMode = mobileQuery.matches ? 'mobile' : 'canonical';
    var previousMode = html.dataset.rlmProductActiveMode || '';
    var crossedBreakpoint = previousMode !== '' && previousMode !== activeMode;
    html.dataset.rlmProductActiveMode = activeMode;

    function money(value) {
      var amount = Number(value);
      if (!Number.isFinite(amount)) return '';
      return new Intl.NumberFormat('en-GB', { style: 'currency', currency: 'GBP' }).format(amount / 100);
    }

    function variantData(select) {
      var scope = select.closest('[data-rlm-product-media], .rlm-product-detail, [data-rlm-root]');
      var data = scope && scope.querySelector('[data-rlm-product-variants]');
      if (!data) return null;
      try {
        var payload = JSON.parse(data.textContent || '[]');
        return {
          scope: scope,
          variants: Array.isArray(payload) ? payload : payload.variants || []
        };
      } catch (error) {
        return null;
      }
    }

    function setMedia(scope, variant) {
      var media = variant.featured_media || variant.featured_image || {};
      var mediaId = String(media.id || variant.featured_media_id || '');
      if (!mediaId) return;
      var slides = Array.prototype.slice.call(scope.querySelectorAll('[data-rlm-product-media-slide]'));
      var slide = slides.find(function (candidate) {
        return String(candidate.getAttribute('data-rlm-product-media-id') || '') === mediaId;
      });
      if (!slide) return;
      var index = Math.max(0, slides.indexOf(slide));
      var track = scope.querySelector('[data-rlm-product-media-track]');
      var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (track) {
        if (typeof track.scrollTo === 'function') {
          track.scrollTo({ left: slide.offsetLeft, behavior: reducedMotion ? 'auto' : 'smooth' });
        } else {
          track.scrollLeft = slide.offsetLeft;
        }
      }
      scope.querySelectorAll('[data-rlm-product-media-dot]').forEach(function (dot) {
        var dotMediaId = String(dot.getAttribute('data-rlm-product-media-id') || '');
        var dotIndex = Number(dot.getAttribute('data-rlm-product-media-index')) || 0;
        var active = dotMediaId ? dotMediaId === mediaId : dotIndex === index;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-current', active ? 'true' : 'false');
      });
      var current = scope.querySelector('[data-rlm-product-media-current]');
      if (current) current.textContent = String(index + 1);
    }

    function sync(select) {
      var productData = variantData(select);
      if (!productData) return;
      var variant = productData.variants.find(function (candidate) {
        return String(candidate.id) === String(select.value);
      });
      if (!variant) return;

      var scope = productData.scope;
      var form = select.closest('form');
      var price = scope.querySelector('[data-rlm-product-price]');
      var compareAt = scope.querySelector('[data-rlm-product-compare-at]');
      var priceBasis = scope.querySelector('.rlm-price [data-price-basis]');
      var sku = scope.querySelector('[data-rlm-product-sku]');
      var skuRow = scope.querySelector('[data-rlm-product-sku-row]');
      var button = scope.querySelector('[data-rlm-product-add]') || (form && form.querySelector('[data-rlm-add-button]'));
      var label = button && (button.querySelector('[data-rlm-add-label]') || button);
      var available = variant.available !== false;

      if (price) price.textContent = Number(variant.price) > 0 ? money(variant.price) : 'Price on enquiry';
      if (priceBasis) priceBasis.hidden = Number(variant.price) <= 0;
      if (compareAt) {
        var hasCompareAt = Number(variant.price) > 0 && Number(variant.compare_at_price) > Number(variant.price);
        compareAt.textContent = hasCompareAt ? money(variant.compare_at_price) : '';
        compareAt.hidden = !hasCompareAt;
      }
      if (sku) {
        sku.textContent = variant.sku || '';
      }
      if (skuRow) skuRow.hidden = !variant.sku;
      if (form) {
        var idInput = form.querySelector('input[name="id"]');
        if (idInput) idInput.value = variant.id;
      }
      if (button) {
        button.disabled = !available;
        button.setAttribute('aria-disabled', available ? 'false' : 'true');
      }
      if (label) label.textContent = available ? 'Add to quote' : 'Unavailable';

      try {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState(window.history.state, '', url.pathname + url.search + url.hash);
      } catch (error) {
        // The selected option and native form remain usable if History API URL parsing fails.
      }
      setMedia(scope, variant);
    }

    function variantIdFromUrl() {
      try {
        var value = new URL(window.location.href).searchParams.get('variant') || '';
        return /^\d+$/.test(value) ? value : '';
      } catch (error) {
        return '';
      }
    }

    function syncMobileFromUrl(variantId) {
      if (!variantId) return;
      document.querySelectorAll('[data-rlm-variant-select]').forEach(function (select) {
        var productData = variantData(select);
        var hasVariant = productData && productData.variants.some(function (variant) {
          return String(variant.id) === variantId;
        });
        if (!hasVariant) return;
        select.value = variantId;
        sync(select);
      });
    }

    function syncCanonicalFromUrl(variantId) {
      if (!variantId) return;
      document.querySelectorAll('#site-main [data-variant-selection]').forEach(function (selection) {
        if (typeof selection.getProduct !== 'function') return;
        selection.getProduct().then(function (product) {
          if (mobileQuery.matches || variantIdFromUrl() !== variantId || !product || !Array.isArray(product.variants)) return;
          var variant = product.variants.find(function (candidate) {
            return String(candidate.id) === variantId;
          });
          if (!variant) return;

          var optionUpdates = Array.prototype.map.call(selection.querySelectorAll('options-selection'), function (optionsSelection) {
            if (typeof optionsSelection.setSelectedOptions !== 'function') return Promise.resolve();
            return optionsSelection.setSelectedOptions(variant.options || []);
          });

          Promise.all(optionUpdates).then(function () {
            if (!mobileQuery.matches && variantIdFromUrl() === variantId && String(selection.variant) !== variantId) {
              selection.variant = variantId;
            }
          });
        });
      });
    }

    function syncQuantityForActiveTree() {
      var canonical = document.querySelector('#site-main form[data-product-form] [data-quantity-input][name="quantity"]');
      var mobile = document.querySelector('[data-rlm-product-media] form [data-rlm-quantity-input][name="quantity"], .rlm-product-detail form [data-rlm-quantity-input][name="quantity"]');
      var source = mobileQuery.matches ? canonical : mobile;
      var target = mobileQuery.matches ? mobile : canonical;
      if (!source || !target) return;
      var quantity = Math.max(1, parseInt(source.value, 10) || 1);
      target.value = String(quantity);
      target.dispatchEvent(new Event('change', { bubbles: true }));
    }

    var currentVariantId = variantIdFromUrl();
    if (mobileQuery.matches) syncMobileFromUrl(currentVariantId);
    else syncCanonicalFromUrl(currentVariantId);
    if (crossedBreakpoint) syncQuantityForActiveTree();

    if (alreadyBound) return;
    html.dataset.rlmVariantSyncBound = 'true';

    document.addEventListener('change', function (event) {
      var select = event.target.closest && event.target.closest('[data-rlm-variant-select]');
      if (select) sync(select);
    });
  }

  function repairMobileKeyboardNav() {
    if (html.dataset.rlMobileKeyboardNavBound) return;
    html.dataset.rlMobileKeyboardNavBound = 'true';

    var viewport = window.visualViewport || null;
    var baselineHeight = Math.max(window.innerHeight || 0, viewport ? viewport.height : 0);
    var pendingUpdate = null;
    var textInputTypes = {
      date: true,
      'datetime-local': true,
      email: true,
      month: true,
      number: true,
      password: true,
      search: true,
      tel: true,
      text: true,
      time: true,
      url: true,
      week: true
    };

    function isTextEntryElement(element) {
      if (!element || element === document.body) return false;
      if (element.isContentEditable) return true;
      var tag = element.tagName ? element.tagName.toLowerCase() : '';
      if (tag === 'textarea') return !element.disabled && !element.readOnly;
      if (tag !== 'input' || element.disabled || element.readOnly) return false;
      var type = (element.getAttribute('type') || 'text').toLowerCase();
      return !!textInputTypes[type];
    }

    function focusedTextEntry() {
      return isTextEntryElement(document.activeElement);
    }

    function setKeyboardState(isOpen, offset) {
      var body = document.body;
      var bottomNav = document.querySelector('.rlm-bottom-nav');
      html.classList.toggle('rl-mobile-keyboard-open', isOpen);
      if (body) body.classList.toggle('rl-mobile-keyboard-open', isOpen);

      if (isOpen) {
        html.style.setProperty('--rl-mobile-keyboard-offset', Math.max(0, Math.round(offset || 0)) + 'px');
        if (bottomNav) {
          bottomNav.dataset.rlKeyboardRequiresInert = 'true';
          if (!bottomNav.hasAttribute('inert')) {
            bottomNav.setAttribute('inert', '');
            bottomNav.dataset.rlKeyboardMadeInert = 'true';
          } else if (bottomNav.dataset.rlmMenuMadeInert === 'true') {
            bottomNav.dataset.rlKeyboardMadeInert = 'true';
          }
          if (!Object.prototype.hasOwnProperty.call(bottomNav.dataset, 'rlKeyboardAriaHiddenPrevious')) {
            bottomNav.dataset.rlKeyboardAriaHiddenPrevious = bottomNav.hasAttribute('aria-hidden')
              ? String(bottomNav.getAttribute('aria-hidden'))
              : '__missing__';
          }
          bottomNav.setAttribute('aria-hidden', 'true');
          bottomNav.style.setProperty('opacity', '0', 'important');
          bottomNav.style.setProperty('pointer-events', 'none', 'important');
          bottomNav.style.setProperty('transform', 'translate3d(0, 110%, 0)', 'important');
        }
      } else {
        html.style.removeProperty('--rl-mobile-keyboard-offset');
        if (bottomNav) {
          if (bottomNav.dataset.rlKeyboardRequiresInert === 'true' && bottomNav.dataset.rlKeyboardMadeInert === 'true') {
            if (document.body && document.body.classList.contains('rlm-menu-open')) {
              bottomNav.dataset.rlmMenuMadeInert = 'true';
            } else if (bottomNav.dataset.rlmMenuMadeInert !== 'true') {
              bottomNav.removeAttribute('inert');
            }
          }
          delete bottomNav.dataset.rlKeyboardRequiresInert;
          delete bottomNav.dataset.rlKeyboardMadeInert;
          if (Object.prototype.hasOwnProperty.call(bottomNav.dataset, 'rlKeyboardAriaHiddenPrevious')) {
            var previousAriaHidden = bottomNav.dataset.rlKeyboardAriaHiddenPrevious;
            if (previousAriaHidden === '__missing__') bottomNav.removeAttribute('aria-hidden');
            else bottomNav.setAttribute('aria-hidden', previousAriaHidden);
            delete bottomNav.dataset.rlKeyboardAriaHiddenPrevious;
          }
          bottomNav.style.removeProperty('opacity');
          bottomNav.style.removeProperty('pointer-events');
          bottomNav.style.removeProperty('transform');
        }
      }
    }

    function updateBaseline() {
      var currentHeight = Math.max(window.innerHeight || 0, viewport ? viewport.height : 0);
      if (currentHeight > baselineHeight) baselineHeight = currentHeight;
    }

    function updateKeyboardState() {
      pendingUpdate = null;

      if (!mobileQuery.matches) {
        updateBaseline();
        setKeyboardState(false, 0);
        return;
      }

      var hasTextFocus = focusedTextEntry();
      var layoutHeight = window.innerHeight || baselineHeight;
      var visualHeight = viewport ? viewport.height : layoutHeight;
      var viewportOffset = viewport ? viewport.offsetTop || 0 : 0;
      var shrinkFromLayout = Math.max(0, layoutHeight - visualHeight - viewportOffset);
      var shrinkFromBaseline = Math.max(0, baselineHeight - visualHeight);
      var keyboardOffset = Math.max(shrinkFromLayout, shrinkFromBaseline);

      if (!hasTextFocus && keyboardOffset < 90) updateBaseline();
      setKeyboardState(hasTextFocus || keyboardOffset > 90, keyboardOffset);
    }

    function scheduleKeyboardUpdate(delay) {
      window.clearTimeout(pendingUpdate);
      pendingUpdate = window.setTimeout(updateKeyboardState, delay || 0);
    }

    document.addEventListener('focusin', function () {
      scheduleKeyboardUpdate(0);
    }, true);

    document.addEventListener('focusout', function () {
      scheduleKeyboardUpdate(140);
    }, true);

    document.addEventListener('pointerdown', function (event) {
      if (!mobileQuery.matches || !focusedTextEntry() || isTextEntryElement(event.target)) return;
      document.activeElement.blur();
      scheduleKeyboardUpdate(0);
    }, true);

    window.addEventListener('resize', function () {
      scheduleKeyboardUpdate(0);
    }, { passive: true });

    window.addEventListener('orientationchange', function () {
      baselineHeight = 0;
      scheduleKeyboardUpdate(260);
    }, { passive: true });

    window.addEventListener('pageshow', function () {
      scheduleKeyboardUpdate(0);
    }, { passive: true });

    if (viewport) {
      viewport.addEventListener('resize', function () {
        scheduleKeyboardUpdate(0);
      }, { passive: true });

      viewport.addEventListener('scroll', function () {
        scheduleKeyboardUpdate(0);
      }, { passive: true });
    }

    scheduleKeyboardUpdate(0);
  }

  function run() {
    updateFinanceHeading();
    repairQuoteHelpCards();
    repairCatalogue();
    repairMobileSearchPredictive();
    repairMobileProductVariants();
    repairMobileKeyboardNav();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  if (mobileQuery.addEventListener) {
    mobileQuery.addEventListener('change', run);
  } else if (mobileQuery.addListener) {
    mobileQuery.addListener(run);
  }

  window.addEventListener('pageshow', run, { passive: true });
})();
